import { WritableSignal, effect, signal } from '@angular/core';
export const persistentSignal = <T>(
  initialValue: T,
  {
    key,
    storage = localStorage,
    parseFn = JSON.parse,
    serializeFn = JSON.stringify,
  }: {
    key: string;
    storage?: Storage;
    parseFn?: (serialized: string) => T;
    serializeFn?: (original: T) => string;
  }
): WritableSignal<T> => {
  const oldStoredValue = storage.getItem(key);
  let defaultValue = initialValue;
  if (oldStoredValue !== null) {
    defaultValue = parseFn(oldStoredValue);
  }
  const baseSignal = signal(defaultValue);
  effect(() => {
    storage.setItem(key, serializeFn(baseSignal()));
  });
  return baseSignal;
};
